let safeAppConfig = null;

try {
  const raw = localStorage.getItem('appConfig');
  safeAppConfig = raw ? JSON.parse(raw) : null;

  if (safeAppConfig !== null && typeof safeAppConfig !== 'object') {
    console.warn("appConfig was not an object, resetting.");
    safeAppConfig = null;
    localStorage.removeItem('appConfig');
  }
} catch (e) {
  console.error("Corrupted appConfig in localStorage → resetting.", e);
  safeAppConfig = null;
  localStorage.removeItem('appConfig');
}

export default {
  appConfig: safeAppConfig,

  revision: null,
  menuItems: [],
  companySites: [],
  appointmentStatus: {},
  selectedCompanySite: null,
  chat: false,
  appointments: false,
  appointmentsDate: null,
  defaultColor: 'rgba(23, 42, 208, 0.7)',
  patientSelect: false,
  unreadedMessageCount: 0,
  externalAppointmentCount: 0,
  envProfile: null
};
